import { GetVideoMainTopics_URL, GetVideos_URL, POST_METHOD } from '../../Apis/api';

export const getVideoMainTopics = userId => {
  return fetch(GetVideoMainTopics_URL, {
    method: POST_METHOD,
    body: JSON.stringify(userId),
  }).then(response => {
    return response.json();
  });
};

export const getVideoInTopics = topicRequestBody => {
  return fetch(GetVideos_URL, {
    method: POST_METHOD,
    body: JSON.stringify(topicRequestBody),
  }).then(response => {
    return response.json();
  });
};
